import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class TankDepartmentService extends SingleDepartmentService {
  readonly NAME = 'Tanks';

  private _departmentId: number;

  get departmentId(): number {
    return this._departmentId;
  }

  set departmentId(value: number) {
    this._departmentId = value;
  }

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('Tanks') ||
      roles.includes('TankAdmin') ||
      roles.includes('TanksOperator') ||
      roles.includes('TanksChief')
    ) {
      this.router.navigate(['sb/tank/box']);
      return true;
    }
    return false;
  }
}
